import { useState } from 'react';
import { Flex, Menu, Tabs, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useFlags } from 'flagsmith/react';
import { TabLabel } from 'Components/TabLabel';
import { InsuranceCarriersAdminV2 } from '@/features/insuranceCarriers/components/InsuranceCarriersAdminV2';
import { AgreementsAdmin } from '@/features/agreements/components/AgreementsAdmin';
import { CreateAgreementButton } from '@/features/agreements/components/AgreementsAdmin/Table/CreateAgreementButton';
import { ROUTES } from '@/App/Router/routes';

const { Text } = Typography;

export const AdminPanelV2 = () => {
  const { agreements } = useFlags(['agreements']);
  const hasAgreementsFeature = agreements?.enabled ?? false;
  const navigate = useNavigate();

  const [selectedSection, setSelectedSection] = useState('aseguradoras');

  const menuItems = [
    { key: 'aseguradoras', label: 'Aseguradoras' },
    ...(hasAgreementsFeature ? [{ key: 'convenios', label: 'Convenios' }] : []),
    { key: 'formulario-autos', label: 'Formulario de autos' },
  ];

  return (
    <Tabs
      animated
      items={[
        {
          key: 'operation',
          label: <TabLabel title='Operación' />,
          children: (
            <Flex gap={0} align='flex-start'>
              <Menu
                mode='inline'
                selectedKeys={[selectedSection]}
                onClick={({ key }) => {
                  if (key === 'formulario-autos') {
                    navigate(ROUTES.AUTO_FORM);
                    return;
                  }
                  setSelectedSection(key);
                }}
                items={menuItems}
                style={{
                  width: 160,
                  borderRight: '1px solid #f0f0f0',
                  flexShrink: 0,
                  background: 'transparent',
                }}
              />
              <Flex vertical gap='middle' style={{ flex: 1, paddingLeft: 24 }}>
                {selectedSection === 'aseguradoras' && (
                  <Flex vertical gap='middle'>
                    <Text strong>Controla cómo y cuándo usar estas aseguradoras para cotizaciones.</Text>
                    <InsuranceCarriersAdminV2 />
                  </Flex>
                )}

                {selectedSection === 'convenios' && hasAgreementsFeature && (
                  <Flex vertical gap='middle'>
                    <Text strong>Configura y administra convenios. Define planes, coberturas, tasas y reglas en un mismo lugar.</Text>
                    <Flex justify='flex-end'>
                      <CreateAgreementButton />
                    </Flex>
                    <AgreementsAdmin />
                  </Flex>
                )}
              </Flex>
            </Flex>
          ),
        },
      ]}
    />
  );
};
